<template>
  <section class="evaluation-item">
    <user-evaluations-item-form :isAdmin="true" :user="currentUser"
      :currentEvaluationForm="currentEvaluation"></user-evaluations-item-form>

    <user-evaluations-item-photos :isAdmin="true" :user="currentUser"
      :currentEvaluationPhotos="currentEvaluation"></user-evaluations-item-photos>

    <div class="text-xs-center">
      <v-btn flat small color="red lighten-2" @click="deleteItem(currentEvaluation)"
        :loading="loadingRequest">
        <v-icon small left>fal fa-trash-alt</v-icon> Excluir avaliação
      </v-btn>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

import UserEvaluationsItemForm from '@/components/user/evaluations/UserEvaluationsItemForm'
import UserEvaluationsItemPhotos from '@/components/user/evaluations/UserEvaluationsItemPhotos'

export default {
  props: ['evaluation', 'user'],

  data: () => ({
    currentStep: 1,
    photos: [null],
    loadingRequest: false,
    currentUser: {},
    currentEvaluation: {}
  }),

  methods: {
    deleteItem (item, confirmUnRequired) {
      this.loadingRequest = true
      // eslint-disable-next-line
      const path = `${API.userEvaluations}/${item._id}`

      if (!confirmUnRequired) {
        confirm(`Tem certeza que deseja apagar a avaliação?`) && this.deleteItem(item, true)
        return
      }

      axios.delete(path).then(response => {
        EventBus.$emit('loadUserEvaluations')
        this.loadingRequest = false
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro apagar o item', color: 'error' })
        EventBus.$emit('loadUserEvaluations')
        this.loadingRequest = false
      })
    }
  },

  mounted () {
    if (this.evaluation) {
      this.currentEvaluation = this.evaluation
    }
  },

  components: { UserEvaluationsItemForm, UserEvaluationsItemPhotos }
}
</script>

<style scoped>
.application .theme--light.v-stepper,
.theme--light .v-stepper,
.v-stepper__header {
  box-shadow: none !important;
}

.v-stepper__header {
  background: #f0f0f0;
}

.v-stepper__content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/evaluations/AdminUserShowEvaluationItem.vue